import React from 'react'
import { useListQuery, useMutation } from 'components/graphql'
import query from './gql/listUsersGridView'
import upsertUsers from './gql/upsertUsers'
import { useTranslation } from 'react-i18next'
import GridView from 'components/GridView'
import { useParams } from 'react-router-dom'

const GridViewUser = props => {
	const [t] = useTranslation()
	const [handleUpsert] = useMutation(upsertUsers)
	const { data: tableData } = useListQuery(query)
	const { id: recordId } = useParams()

	const handleSaveRows = e => {
		const records = e.changes.map(({ type, data, key }) => {
			const updatedRecord = {
				...(type === 'update' && key),
				...data
			}
			const { __KEY__, id, __typename, ...fields } = updatedRecord
			return {
				id: key.id,
				fields: fields
			}
		})
		e.promise = handleUpsert({
			variables: { records }
		})
	}

	const tableCols = [{
		caption: t('common.fields.code'),
		dataField: 'code',
		width: 100
	}, {
		caption: t('user_section.fields.name'),
		dataField: 'name'
	}, {
		caption: t('user_section.fields.bill_name'),
		dataField: 'printName'
	}]
	return (
		<GridView
			data={tableData}
			columns={tableCols}
			onSaving={handleSaveRows}
			sectionPath={`/benutzer${recordId ? '/' + recordId : ''}`}
		/>
	)
}

export default GridViewUser
